import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {HomeIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {Tabs} from "@pg-design/tabs";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {isAbroad} from "../../application/utils/is_abroad";
import {getOfferTypeNamePluralCapital} from "../../offer/helpers/OfferType";
import {getPropertyConfiguratorUrl} from "../../property_configurator/utils/get_url_with_params";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {getSearchUrlWithFilters, IGetSearchUrlWithFiltersProps} from "../../search/utils/get_search_url_with_filters";
import {gtmEventListingSwitch} from "../../tracking/google_tag_manager/gtm_event_listing_switch";
import {ListingType} from "../../types/ListingType";
import {ListingTypeTab} from "./ListingTypeTab";

interface IProps {
    filters: SearchFormValuesType;
    offerType?: number;
    additionalParams: IGetSearchUrlWithFiltersProps["additionalParams"];
    currentListingType: ListingType;
    className?: string;
}

export const ListingTypeTabs = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const offerListingOffers = useSelector((state: IRPStore) => state.offerList.list.offers);
    const country = useSelector((state: IRPStore) => state.offerList.list.latestQuery?.country);
    const isAbroadView = isAbroad(country);
    const tabs = useMemo(() => {
        const secondTabLabelByOfferType = props.offerType ? getOfferTypeNamePluralCapital(props.offerType) : "Mieszkania i domy";

        return [
            {
                title: <ListingTypeTab icon={HomeIcon} label="Osiedla" />,
                value: ListingType.OFFERS
            },
            ...(!isAbroadView
                ? [
                      {
                          title: <ListingTypeTab icon={PropertyPlanIcon} label={secondTabLabelByOfferType} />,
                          value: ListingType.PROPERTIES
                      }
                  ]
                : [])
        ];
    }, [props.currentListingType, country, props.offerType]);

    const getUrlToOtherListing = () => {
        if (props.currentListingType === ListingType.OFFERS) {
            return getPropertyConfiguratorUrl(
                {
                    // there is a problem with "time travel", it this case we don't have any region in filters, only full search query
                    // simple solution for that is take region from first listing's offer
                    search: props.filters.search?.regions
                        ? props.filters.search
                        : offerListingOffers[0]?.region
                          ? {regions: [offerListingOffers[0]?.region]}
                          : undefined,
                    type: props.filters.type,
                    rooms: props.filters.rooms,
                    price: props.filters.price,
                    area: props.filters.area,
                    floor_choices: props.filters.floor_choices,
                    construction_end_date: props.filters.construction_end_date,
                    distance: props.filters.distance,
                    rooms_area_type_selected: undefined,
                    kitchen_type: undefined,
                    selected_room: undefined,
                    floors: undefined,
                    world_directions: undefined,
                    loan: undefined,
                    aftermarket: undefined,
                    house_type: props.filters.house_type,
                    house_additional_areas: props.filters.house_additional_areas,
                    house_storeys: props.filters.house_storeys,
                    instalment: undefined
                },
                props.additionalParams
            );
        }

        return getSearchUrlWithFilters({
            singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
            multiRegionLink: rpAppLink.offer.multiList,
            latestQuery: {},
            searchFormValues: props.filters,
            additionalParams: props.additionalParams,
            abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
        }).url;
    };

    const onChange = (listingType: ListingType) => {
        if (listingType === props.currentListingType) {
            return;
        }

        gtmEventListingSwitch(props.currentListingType === ListingType.OFFERS ? "properties" : "offers");
        window.open(getUrlToOtherListing(), "_blank");
    };

    return (
        <Tabs color="gray" onChange={onChange} className={props.className} tabs={tabs} variant="line" fullWidth={!!isMobile} value={props.currentListingType} />
    );
};
import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {HomeIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {Tabs} from "@pg-design/tabs";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {isAbroad} from "../../application/utils/is_abroad";
import {getOfferTypeNamePluralCapital} from "../../offer/helpers/OfferType";
import {getPropertyConfiguratorUrl} from "../../property_configurator/utils/get_url_with_params";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {getSearchUrlWithFilters, IGetSearchUrlWithFiltersProps} from "../../search/utils/get_search_url_with_filters";
import {gtmEventListingSwitch} from "../../tracking/google_tag_manager/gtm_event_listing_switch";
import {ListingType} from "../../types/ListingType";
import {ListingTypeTab} from "./ListingTypeTab";

interface IProps {
    filters: SearchFormValuesType;
    offerType?: number;
    additionalParams: IGetSearchUrlWithFiltersProps["additionalParams"];
    currentListingType: ListingType;
    className?: string;
}

export const ListingTypeTabs = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const offerListingOffers = useSelector((state: IRPStore) => state.offerList.list.offers);
    const country = useSelector((state: IRPStore) => state.offerList.list.latestQuery?.country);
    const isAbroadView = isAbroad(country);
    const tabs = useMemo(() => {
        const secondTabLabelByOfferType = props.offerType ? getOfferTypeNamePluralCapital(props.offerType) : "Mieszkania i domy";

        return [
            {
                title: <ListingTypeTab icon={HomeIcon} label="Osiedla" />,
                value: ListingType.OFFERS
            },
            ...(!isAbroadView
                ? [
                      {
                          title: <ListingTypeTab icon={PropertyPlanIcon} label={secondTabLabelByOfferType} />,
                          value: ListingType.PROPERTIES
                      }
                  ]
                : [])
        ];
    }, [props.currentListingType, country, props.offerType]);

    const getUrlToOtherListing = () => {
        if (props.currentListingType === ListingType.OFFERS) {
            return getPropertyConfiguratorUrl(
                {
                    // there is a problem with "time travel", it this case we don't have any region in filters, only full search query
                    // simple solution for that is take region from first listing's offer
                    search: props.filters.search?.regions
                        ? props.filters.search
                        : offerListingOffers[0]?.region
                          ? {regions: [offerListingOffers[0]?.region]}
                          : undefined,
                    type: props.filters.type,
                    rooms: props.filters.rooms,
                    price: props.filters.price,
                    area: props.filters.area,
                    floor_choices: props.filters.floor_choices,
                    construction_end_date: props.filters.construction_end_date,
                    distance: props.filters.distance,
                    rooms_area_type_selected: undefined,
                    kitchen_type: undefined,
                    selected_room: undefined,
                    floors: undefined,
                    world_directions: undefined,
                    loan: undefined,
                    aftermarket: undefined,
                    house_type: props.filters.house_type,
                    house_additional_areas: props.filters.house_additional_areas,
                    house_storeys: props.filters.house_storeys,
                    instalment: undefined
                },
                props.additionalParams
            );
        }

        return getSearchUrlWithFilters({
            singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
            multiRegionLink: rpAppLink.offer.multiList,
            latestQuery: {},
            searchFormValues: props.filters,
            additionalParams: props.additionalParams,
            abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
        }).url;
    };

    const onChange = (listingType: ListingType) => {
        if (listingType === props.currentListingType) {
            return;
        }

        gtmEventListingSwitch(props.currentListingType === ListingType.OFFERS ? "properties" : "offers");
        window.open(getUrlToOtherListing(), "_blank");
    };

    return (
        <Tabs color="gray" onChange={onChange} className={props.className} tabs={tabs} variant="line" fullWidth={!!isMobile} value={props.currentListingType} />
    );
};
